import { useLanguageData } from '@/common/hooks/useLanguageData';
import { ORDER_STATUS_PHASE } from '../constants/orderStatus.constants';
import {
	BrandMark,
	BrandRow,
	DotsRow,
	Message,
	SpinnerRing,
	StatusCard,
	StatusPill,
	Title,
	VisualBlock,
} from '../orderStatusPage.styles';

const OrderStatusPending = () => {
	const t = useLanguageData('chat');

	return (
		<StatusCard $phase={ORDER_STATUS_PHASE.VERIFYING} aria-live='polite'>
			<BrandRow>
				<BrandMark>SoftAI</BrandMark>
				<StatusPill $phase={ORDER_STATUS_PHASE.VERIFYING}>
					{t.orderStatusPillVerifying}
				</StatusPill>
			</BrandRow>
			<VisualBlock>
				<SpinnerRing aria-hidden='true' />
				<Title>{t.orderStatusVerifyingPayment}</Title>
				<Message>{t.orderStatusVerifyingPaymentDescription}</Message>
				<DotsRow aria-hidden='true'>
					<span />
					<span />
					<span />
				</DotsRow>
			</VisualBlock>
		</StatusCard>
	);
};

export default OrderStatusPending;
